import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-68116327"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rework" }
const _hoisted_2 = { class: "rework_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("单据类型")
], -1))
const _hoisted_4 = { class: "rework_list_item_right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("入库仓库")
], -1))
const _hoisted_6 = { class: "rework_list_item_right" }
const _hoisted_7 = { class: "rework_qd" }
const _hoisted_8 = { class: "rework_qd_title" }
const _hoisted_9 = { class: "rework_qd_title_left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "增加入库", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "rework_qd_list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("入库货位")
], -1))
const _hoisted_17 = { class: "rework_qd_item_right" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("入库物料")
], -1))
const _hoisted_20 = { class: "rework_qd_item_right" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序", -1))
const _hoisted_23 = { class: "rework_qd_item_right" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "*"),
  /*#__PURE__*/_createTextVNode("质量属性")
], -1))
const _hoisted_26 = { class: "rework_qd_item_right" }
const _hoisted_27 = { class: "rework_qd_item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号", -1))
const _hoisted_29 = { class: "rework_qd_item_right" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "rework_qd_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "*", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("入库数量")
const _hoisted_34 = { class: "rework_qd_item_right" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rework_zw" }, null, -1))

import { onMounted, ref, reactive } from 'vue'
    import { useRouter } from 'vue-router'
    import { Toast } from 'vant'
    import { getListByWarehouseId, wOutBoundForStockUp } from '@/apis/WorkOrderAPI'
    import { getListByMaterialId } from '@/apis/ExWarehouse'
    import Warehouse from '@/components/common/Warehouse.vue'
    import Material from '@/components/newCom/Material.vue'
    import Quality from '@/components/newCom/quality.vue'
    import Location from '@/components/newCom/location.vue'
    import ProductionProcess from '@/components/newCom/productionProcess.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()
    // 表单数据
    let form: any = reactive({
        warehouseName: '',
        warehouseId: '',
        type: '',
        typeName: ''
    })

    let locationList: any = ref([])
    let location: any = ref(true)
    let productionList: any = ref([])

    let i = ref(0)

    let columns = ref([
        { name: '采购入库', id: 25 },
        { name: '库存调整', id: 28 }
    ])
    const customFieldName = {
      text: 'name'
    };
    let list = ref<Array<any>>([
        {
            batch: '',
            locationId: '',
            locationIdLabel: '',
            locationName: '',
            materialId: '',
            materialName: '',
            num: '',
            hasBom: '',
            procedureId: '',
            procedureName: '',
            qualityType: '',
            qualityTypeName: '',
            unitId: '',
            unitName: ''
        }
    ])
    let warehouseShow = ref<boolean>(false)
    let materialsShow = ref<boolean>(false)
    let qualityShow = ref<boolean>(false)
    let locationShow = ref<boolean>(false)
    let typeShow = ref<boolean>(false)
    let productionShow = ref<boolean>(false)

    // 打开选择物料
    const openMaterial = (index: number) => {
        i.value = index
        materialsShow.value = true
    }
    // 打开选择物料
    const openQ = (index: number) => {
        if (list.value[index].locationIdLabel == 'APPLIANCE_ONTEST' || list.value[index].locationIdLabel == 'APPLIANCE_OFFTEST' || list.value[index].locationIdLabel == 'APPLIANCE_USELESS') {
            return
        }
        i.value = index
        qualityShow.value = true
    }
    // 打开工序
    const openGX = (index: number) => {
        if (!list.value[index].materialId) return Toast('请先选择入库物料')
        i.value = index
        productionShow.value = true
    }
    // 打开选择货位
    const openL = (index: number) => {
        if (!form.warehouseId) return Toast('请选择入库仓库')
        i.value = index
        locationShow.value = true
    }
    const addItem = () => {
        if (!form.warehouseId) return Toast('请选择入库仓库')
        list.value.push({
            batch: '',
            locationId: list.value[list.value.length - 1].locationId,
            locationName: list.value[list.value.length - 1].locationName,
            locationIdLabel: list.value[list.value.length - 1].locationIdLabel,
            materialId: '',
            materialName: '',
            num: '',
            hasBom: '',
            procedureId: '',
            procedureName: '',
            qualityType: list.value[list.value.length - 1].qualityType,
            qualityTypeName: list.value[list.value.length - 1].qualityTypeName,
            unitId: '',
            unitName: ''
        })
    }

    const onConfirm1 = (value: any) => {
        form.typeName = value.name
        form.type = value.id
        if (value.id == 25) {
            list.value.forEach(item => {
                item.procedureId = ''
                item.procedureName = ''
            })
        }
        typeShow.value = false
    };
    const onCancel = () => {
        typeShow.value = false
    }
    
    // 获取当天年月日
    const getDay = () => {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return `${year}-${month <= 9 ? `0${month}` : month}-${day <= 9 ? `0${day}` : day}`
    }

    // 提交
    const onConfirm = () => {
        if (!form.type) return Toast('请选择单据类型')
        if (!form.warehouseId) return Toast('请选择入库仓库')
        if (list.value.length === 0) return Toast('请先添加入库物料')
        for (let i = 0; i < list.value.length; i++) {
            if (!list.value[i].locationId) return Toast(`第${i+1}项入库货位不能为空`)
            if (!list.value[i].materialId) return Toast(`第${i+1}项入库物料不能为空`)
            if (!list.value[i].qualityType) return Toast(`第${i+1}项质量属性不能为空`)
            if (list.value[i].num <= 0) {
                return Toast(`第${i + 1}项入库数量必须大于0`)
            }
        }
        wOutBoundForStockUp({
            type: form.type,
            planDate: getDay(),
            validDate: getDay(),
            warehouseId: form.warehouseId,
            woutboundInBodyBeanList: list.value
        }).then(res => {
            if (res.code === 200) {
                Toast.success({message: '入库成功'})
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 打开选择物料
    const openMs = () => {
        if (!form.warehouseId) return Toast('请先选择出库仓库')
        const { selected }: any = Material.value
        let ids = list.value.map(item => item.id)
        Material.value.selected = ids
        materialsShow.value = true
    }

    // 删除
    const dele = (index: any) => {
        if (list.value.length === 1) {
            Toast('至少保留一条工装信息')
            return
        }
        list.value.splice(index, 1)
    }
    // 关闭仓库选择弹框
    const close = (): void => {
        warehouseShow.value = false
    }
    // 关闭仓库选择弹框
    const close1 = (): void => {
        materialsShow.value = false
    }
    // 关闭仓库选择弹框
    const close2 = (): void => {
        qualityShow.value = false
    }
    // 关闭货位选择弹框
    const close3 = (): void => {
        locationShow.value = false
    }
    // 关闭货位选择弹框
    const close4 = (): void => {
        productionShow.value = false
    }
    // 选择仓库回调
    const getValue = (item: any): void => {
        form.warehouseName = item.name
        form.warehouseId = item.id
        getListByWarehouseId({ wareHouseId: item.id })
            .then(res => {
                if (res.code === 200) {
                    locationList.value = res.data
                    if (res.data.length === 1) {
                        location.value = false
                        list.value.forEach(item => {
                            item.locationId = res.data[0].id
                            item.locationName = res.data[0].unionName
                        })
                        list.value[i.value].locationIdLabel = res.data[0].label
                        if (res.data[0].label === 'APPLIANCE_ONTEST') {
                            list.value[i.value].qualityType = '0'
                            list.value[i.value].qualityTypeName = '合格'
                        } else if (res.data[0].label === 'APPLIANCE_OFFTEST') {
                            list.value[i.value].qualityType = '1'
                            list.value[i.value].qualityTypeName = '不良'
                        } else if (res.data[0].label === 'APPLIANCE_USELESS') {
                            list.value[i.value].qualityType = '2'
                            list.value[i.value].qualityTypeName = '报废'
                        }
                    } else {
                        location.value = true
                        list.value.forEach(item => {
                            item.locationId = res.data[0].id
                            item.locationName = res.data[0].unionName
                        })
                        // list.value.forEach(item => {
                        //     item.locationId = ''
                        //     item.locationName = ''
                        // })
                    }
                }
            })
        warehouseShow.value = false
    }
    // 选择物料
    const getValue1 = (item: any): void => {
        list.value[i.value].materialName = item.mmodelUnionName
        list.value[i.value].materialId = item.id
        list.value[i.value].unitId = item.unitId
        list.value[i.value].hasBom = item.hasBom
        list.value[i.value].unitName = item.umodelName
        // 获取物料下工序
        getListByMaterialId({
            materialId: item.id
        }).then(res => {
            if (res.code === 200) {
                productionList.value = res.data
                list.value[i.value].procedureId = ''
                list.value[i.value].procedureName = ''
            }
        })
        materialsShow.value = false
    }
    // 选择质量属性
    const getValue2 = (item: any): void => {
        list.value[i.value].qualityType = item.id
        list.value[i.value].qualityTypeName = item.name
        qualityShow.value = false
    }
    // 选择货位
    const getValue3 = (item: any): void => {
        list.value[i.value].locationId = item.id
        list.value[i.value].locationName = item.unionName
        list.value[i.value].qualityType = ''
        list.value[i.value].qualityTypeName = ''
        list.value[i.value].locationIdLabel = item.label
        if (item.label === 'APPLIANCE_ONTEST') {
            list.value[i.value].qualityType = '0'
            list.value[i.value].qualityTypeName = '合格'
        } else if (item.label === 'APPLIANCE_OFFTEST') {
            list.value[i.value].qualityType = '1'
            list.value[i.value].qualityTypeName = '不良'
        } else if (item.label === 'APPLIANCE_USELESS') {
            list.value[i.value].qualityType = '2'
            list.value[i.value].qualityTypeName = '报废'
        }
        locationShow.value = false
    }
    // 选择工序
    const getValue4 = (item: any): void => {
        list.value[i.value].procedureId = item.id
        list.value[i.value].procedureName = item.name
        productionShow.value = false
    }
    onMounted(() => {
        // 获取工装信息
        // getLKInfo(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(typeShow) //@ts-ignore
 ? typeShow.value = true : typeShow = true))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).typeName ? 'black' : '')
          }, _toDisplayString(_unref(form).typeName ? _unref(form).typeName : '请选择'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(warehouseShow) //@ts-ignore
 ? warehouseShow.value = true : warehouseShow = true))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).warehouseName ? 'black' : '')
          }, _toDisplayString(_unref(form).warehouseName ? _unref(form).warehouseName : '请选择'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(`入库物料清单${_unref(list).length}`), 1)
        ]),
        _createElementVNode("div", {
          class: "rework_qd_title_right",
          onClick: addItem
        }, _hoisted_13)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              style: {"height":"100%"},
              square: "",
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              (_unref(location))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "rework_qd_item",
                    onClick: ($event: any) => (openL(index))
                  }, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(item.locationName ? 'black' : '')
                      }, _toDisplayString(item.locationName ? item.locationName : '请选择'), 3),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        size: "20",
                        color: "#999999"
                      })
                    ])
                  ], 8, _hoisted_15))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "rework_qd_item",
                onClick: ($event: any) => (openMaterial(index))
              }, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", {
                    class: _normalizeClass(item.materialName ? 'black' : '')
                  }, _toDisplayString(item.materialName ? item.materialName : '请选择'), 3),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "20",
                    color: "#999999"
                  })
                ])
              ], 8, _hoisted_18),
              (_unref(form).type !== 25)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (item.hasBom !== 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rework_qd_item",
                          onClick: ($event: any) => (openGX(index))
                        }, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", {
                              class: _normalizeClass(item.procedureName ? 'black' : '')
                            }, _toDisplayString(item.procedureName ? item.procedureName : '请选择'), 3),
                            _createVNode(_component_van_icon, {
                              name: "arrow",
                              size: "20",
                              color: "#999999"
                            })
                          ])
                        ], 8, _hoisted_21))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "rework_qd_item",
                onClick: ($event: any) => (openQ(index))
              }, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", {
                    class: _normalizeClass(item.qualityTypeName ? 'black' : '')
                  }, _toDisplayString(item.qualityTypeName ? item.qualityTypeName : '请选择'), 3),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "20",
                    color: "#999999"
                  })
                ])
              ], 8, _hoisted_24),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((item.batch) = $event),
                    placeholder: "请输入"
                  }, null, 8, _hoisted_30), [
                    [_vModelText, item.batch]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", null, [
                  _hoisted_32,
                  _hoisted_33,
                  (item.unitName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("(" + _toDisplayString(item.unitName) + ")", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                    placeholder: "0"
                  }, null, 8, _hoisted_35), [
                    [_vModelText, item.num]
                  ])
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _hoisted_36,
    _createElementVNode("div", { class: "rework_footer" }, [
      _createElementVNode("button", {
        class: "rework_footer_submit",
        onClick: onConfirm
      }, "提交")
    ]),
    _createVNode(Warehouse, {
      show: _unref(warehouseShow),
      onClose: close,
      onValue: getValue
    }, null, 8, ["show"]),
    _createVNode(Material, {
      show: _unref(materialsShow),
      onClose: close1,
      onValue: getValue1
    }, null, 8, ["show"]),
    _createVNode(Quality, {
      show: _unref(qualityShow),
      onClose: close2,
      onValue: getValue2
    }, null, 8, ["show"]),
    _createVNode(Location, {
      show: _unref(locationShow),
      list: _unref(locationList),
      onClose: close3,
      onValue: getValue3
    }, null, 8, ["show", "list"]),
    _createVNode(ProductionProcess, {
      show: _unref(productionShow),
      list: _unref(productionList),
      onClose: close4,
      onValue: getValue4
    }, null, 8, ["show", "list"]),
    _createVNode(_component_van_popup, {
      show: _unref(typeShow),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(typeShow) ? (typeShow).value = $event : typeShow = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _unref(columns),
          onConfirm: onConfirm1,
          onCancel: onCancel,
          "columns-field-names": customFieldName
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})